import { useDispatch } from "react-redux";
import TextInput from "../../../../../../components/inputs/textInput/TextInput";
import Loader from "../../../../../../components/loader/Loader";
import Modal from "../../../../../../components/modal/Modal";
import TextWrapper from "../../../../../../components/textWrapper/TextWrapper";
import { addPlayerToTournament } from "../../../../../../features/players/playersSlice";
import styles from "./addPlayer.module.css";
import OnePlayer from "./onePlayer/OnePlayer";

const AddPlayer = ({
  onClose,
  value,
  onChange,
  loading,
  players,
  gameName,
  tournamentId,
  tableId,
  tournamentType = "solo",
}) => {
  const dispatch = useDispatch();

  return (
    <Modal data-no-select-box closeModalHandler={onClose}>
      <div className={styles.addNewPlayerModalWrapper}>
        <TextWrapper textStyle={"textMid"}>
          {tournamentType === "squad"
            ? "اضافة فريق الى الجدول"
            : "اضافة لاعب الى الجدول"}
        </TextWrapper>
        <TextInput
          height="50px"
          width="100%"
          borderRadius="10px"
          placeHolder={
            tournamentType === "squad" ? "البحث عن فريق" : "البحث عن لاعب"
          }
          bgColor={"grey"}
          value={value}
          onChange={(e) => onChange(e)}
          data-no-select-box
        />
        <div className={styles.playersWrapper}>
          {loading ? (
            <Loader />
          ) : (
            players?.map((player) => {
              return (
                <OnePlayer
                  player={player}
                  gameName={gameName}
                  tournamentType={tournamentType}
                  key={player._id}
                  onClick={() => {
                    dispatch(
                      addPlayerToTournament({
                        kind: tournamentType === "squad" ? "squad" : "user",
                        userId: tournamentType === "squad" ? null : player?._id,
                        squadId:
                          tournamentType === "squad" ? player?._id : null,
                        tableId,
                        tournamentId,
                      }),
                    );
                    onClose();
                  }}
                />
              );
            })
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AddPlayer;
